import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getShortDateDisplay } from '../../util/datetime';
import TimeTable from '../time-table/TimeTable';
import { selectContext } from '../ticket/ticketSlice';
import Grid from '@mui/material/Grid2';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Link from '@mui/material/Link';
import { Link as RLink } from "react-router-dom";

import Box from '@mui/material/Box';
import { ToolBar } from './RightToolBar';
import { SerializedError } from '../../util/types';
import {
  selectTicket,
  TicketItem,
} from './ticketSlice';
import { useTicketByDelTagQuery, TicketItemsResponse } from '../../api/ticket';
import { toTimeRows } from '../time-table/timeTableSlice';
import TicketPaneViewer from './TicketPaneViewer';

const vcontentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	display: 'flex',
	//backgroundColor: 'grey',
};
const contentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	//overflow: 'auto',
	display: 'flex',
	//backgroundColor: 'grey',
};
const colOneStyle = {
	height: '100%',
	flexGrow: 5,
	width: '50%',
	//backgroundColor: '#eeeeee',
	//overflow: 'auto',
};
const colTwoStyle = {
	height: '100%',
	flexGrow: 4,
	//backgroundColor: 'green',
	width: '50%',
	//overflow: 'auto',
};
const viewStyle = {
	height: `calc(100% - 44px)`,
	overflow: 'auto',
	padding: 2,
	width: '100%',
	//height: '100%r',
	//backgroundColor: 'purple',
};

export default function TicketByDelTag() {
	let {tag} = useParams();
	const tag_str = tag ? tag: null;
	const dispatch = useAppDispatch();
	const minDate = new Date();
	minDate.setHours(0, 0, 0, 0);
	const {
		//data: pageResult,
		data,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useTicketByDelTagQuery({tag: tag_str, end_min: minDate.toISOString()}, { refetchOnMountOrArgChange: true});
	//const tItems = useAppSelector(selectContext(cid, minDate.toISOString()));
	return (
		<TicketViewerLeft
			data={data}
			isLoading={isLoading}
			isFetching={isFetching}
			isSuccess={isSuccess}
			isError={isError}
			error={error}
		/>
	);
}


interface QueryProps {
	data: TicketItemsResponse | undefined;
	isLoading: boolean;
	isFetching: boolean;
	isSuccess: boolean;
	isError: boolean;
	error: FetchBaseQueryError | SerializedError | undefined;
};

export function TicketViewerLeft({
	data,
	isLoading,
	isFetching,
	isSuccess,
	isError,
	error,
}: QueryProps) {
	//const ticket = useAppSelector(selectTicket(id ? id : ""));
	let content: React.ReactNode

	if (isLoading) {
		content = <TicketViewerLoading />
	} else if (isFetching) {
		content = <TicketViewerFetching />
	} else if (isSuccess && data) {
		content = <TicketViewerSuccess data={data}/>
	} else if (isError) {
		content = <TicketViewerError error={error} />
	}
	return (
		<Box sx={{'width': '100%'}}>
			{
				content
			}
		</Box>
	)
}




function TicketViewerSuccess({data}: {data: TicketItemsResponse}) {
	const tRows = toTimeRows(getList(data.ticket_items));
	const now = new Date();
	return (
		<Box sx={vcontentStyle}>
			<ToolBar />
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={viewStyle}>
                        <Grid container spacing={0} sx={vcontentStyle}>
							<Grid size={{ xs: 12, md: 6}}>
					<Box sx={{height: 45}}>
					</Box>
						<TimeTable
							data={tRows}
							refDate={now}
							linkTo={"parent"}
							titleLink={(id: string) => '/ticket/view/' + id}
						/>
                            </Grid>
                        </Grid>
					</Box>
				</Box>
			</Box>
		</Box>
	);
    /*
	return (
		<Box sx={vcontentStyle}>
			<ToolBar />
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<TimeTable
							data={tRows}
							refDate={now}
							linkTo={"parent"}
							titleLink={(id: string) => '/ticket/view/' + id}
						/>
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
        //v*/
}

function TicketViewerLoading() {
	return (
		<Box>Loading</Box>
	);
}
function TicketViewerFetching() {
	return (
		<Box>Error</Box>
	);
}
function TicketViewerError({error}:
								  {error: FetchBaseQueryError | SerializedError | undefined }) {
	return (
		<Box>Loading</Box>
	);
}


const getList = (arg: {[key: string]: TicketItem;}) => {
	let res: TicketItem[] = [];
	for (const key in arg) {
		const ti = arg[key];
		res.push(ti);
	}
	return res;
}

	let plannedStartInPeriod: TicketItem[] = [];
